import React from 'react'
import { Navigate } from 'react-router-dom'

const SmartConnectListPageWrapper = () => {
  return <Navigate to={'/smart_connector/list'}/>
}

export default SmartConnectListPageWrapper